export const ALLOW_SCROLL = 'js-allow-scroll';
export const ANALYTICS_TARGET = 'js-analytics-target';
